import { Component, Input } from '@angular/core';
import {CampaignState} from '@enums/campaingState.enum';
import {LocationsFacadeService} from '@services/locations/locations-facade.service';

@Component({
  selector: 'page-header',
  templateUrl: './page-header.component.html',
  styleUrls: ['./page-header.component.sass']
})
export class PageHeaderComponent {
  @Input() title: string;
  @Input() subtitle: string;
  @Input() statusIndicator?: CampaignState = null;

  // @deprecated
  @Input() icon: string;
  // @deprecated
  @Input() bgColor: string;

  businessLocations$ = this.locationsFacadeService.getLocationTotal$()

  constructor(
    private locationsFacadeService: LocationsFacadeService,
  ) { }
}
